import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b584528c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width"]
const _hoisted_2 = ["width"]
const _hoisted_3 = ["width"]
const _hoisted_4 = ["width"]
const _hoisted_5 = ["width"]
const _hoisted_6 = ["width"]
const _hoisted_7 = ["width"]
const _hoisted_8 = ["width"]
const _hoisted_9 = ["width"]
const _hoisted_10 = ["width"]
const _hoisted_11 = ["width"]
const _hoisted_12 = ["width"]
const _hoisted_13 = ["width"]
const _hoisted_14 = ["width"]
const _hoisted_15 = ["width"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "A"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "B"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "C"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "D"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "E"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "F"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "G"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "H"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "I"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "1"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "2"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "3 = 1 * 2")
], -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "12",
  class: "text-center fst-italic"
}, "Không có dữ liệu", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "break-word" }
const _hoisted_24 = { class: "break-word" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_26 = { class: "break-word" }
const _hoisted_27 = { class: "text-end" }
const _hoisted_28 = { class: "text-end" }
const _hoisted_29 = { class: "text-end fw-bolder" }
const _hoisted_30 = { class: "bao-cao-table-total-row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bolder text-center",
  colspan: "9"
}, "Cộng", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_34 = { class: "text-end fw-bolder" }

import { computed, PropType } from "vue";
import { IHoaDonNhapKhoResponseBase } from "@/core/interfaces/ApiResponses";
import { useDateTime } from "@/core/hooks/use-date-time-hook";
import {
  calcLineAmount,
  formatAmount,
  formatQuantity,
  formatUnitPrice,
} from "@/core/helpers/number-format";
import {
  REPORT_COLUMN_WIDTHS,
  REPORT_COLUMN_WIDTHS_GROUP,
} from "@/components/shared/vat-tu-table/vat-tu-table-column-widths";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChiTietNhapTable',
  props: {
  isPrintModal: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  items: {
    type: Array as PropType<IHoaDonNhapKhoResponseBase[]>,
    default: () => [],
  },
  stripe: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const colW = {
  stt: REPORT_COLUMN_WIDTHS.stt,
  so: REPORT_COLUMN_WIDTHS.soPhieuXuat,
  ngay: REPORT_COLUMN_WIDTHS.ngay,
  ma: REPORT_COLUMN_WIDTHS.ma,
  ten: REPORT_COLUMN_WIDTHS.ten,
  dacTinh: REPORT_COLUMN_WIDTHS.dacTinh,
  dvt: REPORT_COLUMN_WIDTHS.dvt,
  donGia: REPORT_COLUMN_WIDTHS.donGia,
  soLuong: REPORT_COLUMN_WIDTHS.soLuong,
  thanhTien: REPORT_COLUMN_WIDTHS.thanhTien,
  hoaDon: REPORT_COLUMN_WIDTHS.soPhieuXuat + REPORT_COLUMN_WIDTHS.ngay,
  phieuNhap: REPORT_COLUMN_WIDTHS.soPhieuXuat + REPORT_COLUMN_WIDTHS.ngay,
  nhapTrongKy: REPORT_COLUMN_WIDTHS_GROUP.quantityDonGiaThanhTienGroup,
};

const props = __props;

const { formatDisplayingDate } = useDateTime();

const sttCal = (indexHoaDon: number, indexVatTu: number) => {
  let curIndex = 0;

  for (let i = 0; i < indexHoaDon; i++) {
    curIndex += props.items[i].vat_tu_nhap_kho.length;
  }

  return curIndex + 1 + indexVatTu;
};

const isLastDataRow = (indexHoaDon: number, indexVatTu: number) => {
  const lastHoaDonIndex = props.items.length - 1;

  if (indexHoaDon !== lastHoaDonIndex) {
    return false;
  }

  return indexVatTu === props.items[lastHoaDonIndex].vat_tu_nhap_kho.length - 1;
};

const totalNhapTrongKy = computed(() => {
  let result = 0;

  props.items.forEach(({ vat_tu_nhap_kho: vatTuNhapKho }) => {
    vatTuNhapKho.forEach(({ pivot: { don_gia, so_luong } }) => {
      result += +don_gia * +so_luong;
    });
  });

  return formatAmount(Math.round(result));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", {
    class: _normalizeClass({
      'table-striped': __props.stripe,
      'bao-cao-table--print': __props.isPrintModal,
    }),
    style: { width: '100%', fontSize: '0.8rem' }
  }, [
    _createElementVNode("colgroup", null, [
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.stt}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.so}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.ngay}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.so}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.ngay}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.ma}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.ten}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.dacTinh}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.dvt}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.soLuong}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.donGia}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.thanhTien}px` })
      }, null, 4)
    ]),
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center",
          width: colW.stt
        }, "TT", 8, _hoisted_1),
        _createElementVNode("th", {
          colspan: "2",
          class: "text-center",
          width: colW.hoaDon
        }, "Hoá Đơn", 8, _hoisted_2),
        _createElementVNode("th", {
          colspan: "2",
          class: "text-center break-word",
          width: colW.phieuNhap
        }, " Phiếu nhập ", 8, _hoisted_3),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center break-word",
          width: colW.ma
        }, " Mã VT ", 8, _hoisted_4),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center break-word",
          width: colW.ten
        }, " Tên vật tư ", 8, _hoisted_5),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center break-word",
          width: colW.dacTinh
        }, " Đặc tính ", 8, _hoisted_6),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center break-word",
          width: colW.dvt
        }, " Đơn vị tính ", 8, _hoisted_7),
        _createElementVNode("th", {
          colspan: "3",
          class: "text-center",
          width: colW.nhapTrongKy
        }, " Nhập trong kỳ ", 8, _hoisted_8)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("th", {
          class: "text-center",
          width: colW.so
        }, "Số", 8, _hoisted_9),
        _createElementVNode("th", {
          class: "text-center",
          width: colW.ngay
        }, "Ngày", 8, _hoisted_10),
        _createElementVNode("th", {
          class: "text-center",
          width: colW.so
        }, "Số", 8, _hoisted_11),
        _createElementVNode("th", {
          class: "text-center",
          width: colW.ngay
        }, "Ngày", 8, _hoisted_12),
        _createElementVNode("th", {
          class: "text-center",
          width: colW.soLuong
        }, "Số lượng", 8, _hoisted_13),
        _createElementVNode("th", {
          class: "text-center",
          width: colW.donGia
        }, "Đơn giá", 8, _hoisted_14),
        _createElementVNode("th", {
          class: "text-center",
          width: colW.thanhTien
        }, "Thành tiền", 8, _hoisted_15)
      ]),
      _hoisted_16
    ]),
    _createElementVNode("tbody", null, [
      (!__props.items.length)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_19))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (hoaDon, indexHoaDon) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: hoaDon.id
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hoaDon.vat_tu_nhap_kho, (vatTu, indexVatTu) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: vatTu.id,
                    class: _normalizeClass({
              'bao-cao-table-data-row': __props.isPrintModal,
              'bao-cao-table-data-row--last':
                __props.isPrintModal && isLastDataRow(indexHoaDon, indexVatTu),
            })
                  }, [
                    _createElementVNode("td", _hoisted_20, _toDisplayString(sttCal(indexHoaDon, indexVatTu)), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(hoaDon.so_hoa_don ?? "-"), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(formatDisplayingDate)(new Date(hoaDon.ngay_hoa_don))), 1),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(hoaDon.so_phieu), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(formatDisplayingDate)(new Date(hoaDon.ngay_hoan_thanh))), 1),
                    _createElementVNode("td", _hoisted_23, _toDisplayString(vatTu.ma_vat_tu), 1),
                    _createElementVNode("td", _hoisted_24, _toDisplayString(vatTu.ten_vat_tu), 1),
                    _hoisted_25,
                    _createElementVNode("td", _hoisted_26, _toDisplayString(vatTu.don_vi_tinh), 1),
                    _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(formatQuantity)(vatTu.pivot.so_luong)), 1),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(_unref(formatUnitPrice)(vatTu.pivot.don_gia)), 1),
                    _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(formatAmount)(
                  _unref(calcLineAmount)(+vatTu.pivot.don_gia, +vatTu.pivot.so_luong)
                )), 1)
                  ], 2))
                }), 128))
              ], 64))
            }), 128)),
            _createElementVNode("tr", _hoisted_30, [
              _hoisted_31,
              _hoisted_32,
              _hoisted_33,
              _createElementVNode("td", _hoisted_34, _toDisplayString(totalNhapTrongKy.value), 1)
            ])
          ], 64))
    ])
  ], 2))
}
}

})